import React from "react";
import EmptyPage from "../../components/Main/404";

function Empty() {
  return <EmptyPage />;
}

export default Empty;
